import { styled } from "@mui/system";
import { Typography } from "@mui/material";
const Title = styled(Typography)(() => ({
  textAlign: "center",
  fontWeight: 700,
  maxWidth: "300px",
}));

export default Title;